export default "__VITE_ASSET__DYpCBSQ1__"